import { onBeforeRouteLeave } from 'vue-router';
import { onActivated } from 'vue';

/**
 * 当页面使用KeepAlive功能时(在路由配置meta中设置页面keepAlive: true)通过路由重新进入页面而非点击返回进入时需要刷新页面数据
 * @param leaveToRouteNames 从当前页面导航进入其他页面再返回需要keepalive功能
 * @param refreshCallback 此方法中刷新当前页面数据
 */
export function useRouteKeepAliveRefreshPage(leaveToRouteNames: string[], refreshCallback: () => void) {
  let shouldRefreshPage = true;
  onBeforeRouteLeave((to) => {
    // console.log('onBeforeRouteLeave');
    if (leaveToRouteNames.indexOf(to.name as string) != -1) {
      shouldRefreshPage = false;
    } else {
      shouldRefreshPage = true;
    }
  });
  onActivated(() => {
    // console.log('onActivated:', shouldRefreshPage);
    if (shouldRefreshPage) {
      refreshCallback && refreshCallback();
    }
  });
  function resetKeepAliveStatus() {
    shouldRefreshPage = true;
  }
  return resetKeepAliveStatus;
}
